// components-dashboard/DashboardSidebar.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFirebaseAuth } from '../contexts/FirebaseAuthContext';
import LogoutModal from '../components/LogoutModal';

const menuItems = [
  { 
    id: 'dashboard', 
    label: 'Dashboard', 
    iconActive: '/Icons/dashboard.svg',
    iconInactive: '/Icons/black-dashboard-icon.svg',
    path: '/dashboard' 
  },
  { 
    id: 'register', 
    label: 'Register Sub-User', 
    iconActive: '/Icons/user-icon.svg',
    iconInactive: '/Icons/black-user-icon.svg',
    path: '/dashboard/subusers'  
  },
  { 
    id: 'projects', 
    label: 'Projects', 
    iconActive: '/Icons/projects-icon.svg',
    iconInactive: '/Icons/black-projects-icon.svg',
    path: '/dashboard/projects'
  },
  { 
    id: 'templates', 
    label: 'Proposal Templates', 
    iconActive: '/Icons/templates-icon.svg',
    iconInactive: '/Icons/black-templates-icon.svg',
    path: '/dashboard/proposal-templates' 
  },
  { 
    id: 'settings', 
    label: 'Settings', 
    iconActive: '/Icons/settings-icon.svg',
    iconInactive: '/Icons/black-settings-icon.svg',
    path: '/dashboard/more-settings'
  },
  { 
    id: 'Manage Subscription', 
    label: 'Manage Subscription', 
    iconActive: '/Icons/manage-subscription-white-logo.svg',
    iconInactive: '/Icons/manage-subscription-black-logo.svg',
    path: '/dashboard/manage-subscription'
  },
];

const DashboardSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useFirebaseAuth();
  const [activeItem, setActiveItem] = useState('dashboard');
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Update active item based on current path
  useEffect(() => {
    const currentPath = location.pathname;
    
    const matchedItem = menuItems.find(item => {
      if (item.path === '/dashboard') {
        return currentPath === '/dashboard';
      }
      return currentPath.startsWith(item.path);
    });

    if (matchedItem) {
      setActiveItem(matchedItem.id);
    } else if (currentPath === '/subusers') {
      setActiveItem('register');
    } else {
      setActiveItem('dashboard');
    }
  }, [location.pathname]);

  const handleItemClick = (item) => {
    setActiveItem(item.id);
    navigate(item.path);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutModal(false);
    logout();
    navigate('/login');
  };

  return (
    <>
      <aside className="fixed left-0 top-0 w-60 h-screen bg-background-body flex flex-col z-50">
        <div className="px-4 py-3 mb-8 m-4">
          <img src="/bidz-logo.svg" alt="BidZ" className="h-8" />
        </div>
        
        <nav className="flex-1 flex flex-col gap-1 border-r border-primary-black-shade-10 -mt-4 p-4">
          {menuItems.map((item) => {
            const isActive = activeItem === item.id;
            return (
              <button
                key={item.id}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all text-sm font-medium ${
                  isActive
                    ? 'bg-gradient-to-r from-primary-blue to-blue-600 text-white shadow-md'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                }`}
                onClick={() => handleItemClick(item)}
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <img 
                    src={isActive ? item.iconActive : item.iconInactive} 
                    alt={item.label}
                    className="w-6 h-6 object-contain"
                  />
                </span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
        
        <div className="w-full  p-4 border-r border-primary-black-shade-10">
          <button 
            onClick={handleLogoutClick}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-500 hover:bg-red-50 transition-all"
          >
            <span className="h-6 w-6 flex items-center justify-center">
              <img 
                src='/Icons/logout.svg'
                alt='logout'
                className="w-6 h-6 object-contain"
              />
            </span>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Logout Modal */}
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleConfirmLogout}
      />
    </>
  );
};

export default DashboardSidebar;
